module.exports = "<div class=\"col-12 m-auto\" style=\"text-align:center; width:100%; text-align:center;\">\n  <i class=\"fa fa-spinner fa-spin\"></i>\n</div>"